import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  AfterViewInit, ChangeDetectionStrategy, OnChanges, SimpleChanges
} from '@angular/core';
import {Router} from '@angular/router';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-custom-button',
  template: `
    <div id="mainDiv" *ngIf="Show" [ngSwitch]="mode">
      <div *ngSwitchCase="'BOTTOM'" class="continue elem">
        <button [disabled]="disabled" class="btn btn-full btn-continue"
                style="background-color: #c8141e; margin-right: 0"
                (click)="clicked()">
          <span>{{LabelText}}</span>
        </button>
      </div>
      <div *ngSwitchDefault class="btn-holder">
        <div class="col col-md-12">
          <div class="row">
            <div *ngIf="!HideMainButton" [ngClass]="BackButton ? 'col-md-6 col-xs-6': 'col-md-12 col-xs-12'"
                 [ngStyle]="BackButton && {padding: '0 15px 0 15px'}">
              <button [disabled]="disabled" type="button" class="btn btn-primary pull-left"
                      (click)="clicked()"
                      style="background-color: #14317a ; border-bottom-color: #14317a ; color: #FFFF;">{{LabelText}}</button>
            </div>
            <div *ngIf="BackButton" [ngClass]="!HideMainButton ? 'col-md-6 col-xs-6': 'col-md-12 col-xs-12'">
              <button type="button" class="btn btn-primary pull-right" (click)="back()"
                      style="background-color: #c8141e; border-bottom-color: #c8141e; color: #FFFF;">
                {{backButtonLabel ? backButtonLabel : 'بازگشت'}}
              </button>
            </div>
          </div>
        </div>
        <!--        <div *ngIf="!BackButton">-->
        <!--          <button [disabled]="disabled" (click)="clicked()" class="btn btn-lg">-->
        <!--            <span>{{LabelText}}</span>-->
        <!--          </button>-->
        <!--        </div>-->
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ]
})
export class CustomButtonComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() LabelText: string;
  @Input() Show: boolean;
  @Input() mode: string;
  @Input() disabled: boolean;
  @Input() BackButton: boolean;
  @Input() HideMainButton: boolean;
  @Output() OnClick = new EventEmitter<void>();
  @Output() OnGoBack = new EventEmitter<void>();
  @Input() backUrl: string;
  @Input() backButtonLabel: string;

  constructor(private cdRef: ChangeDetectorRef, private router: Router) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  clicked() {
    this.OnClick.emit();
  }

  back() {
    this.OnGoBack.emit();
    if (this.backUrl) {
      this.router.navigate([this.backUrl], {
        state: history.state
      });
    }
    // else {
    //   history.back();
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdRef.detectChanges();
  }
}
